
import { Component, Mixins } from "vue-property-decorator";
import { CommonComponentsAccessor } from "../CommonComponentsAccessor";
import { instanceOfICommonComponentsContainable } from "../ICommonComponentsContainable";

@Component
export default class CommonComponentsAccessibleMixin extends Mixins() {
  get commonComponents(): CommonComponentsAccessor {
    const container = instanceOfICommonComponentsContainable(this)
      ? this
      : this.$findAncestor(s => instanceOfICommonComponentsContainable(s));
    return (container && instanceOfICommonComponentsContainable(container))
      ? new CommonComponentsAccessor(container.getCommonComponentsContainer())
      : null;
  }
}
